/* @ngInject */
function AttachmentListController ($scope) {
  const api = {}
  this.getApi = () => api

  activate()

  function activate () {}

  $scope.handleAttachmentClick = (index) => {
    $scope.openPreview({ index })
  }
}

export { AttachmentListController }
